/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import { $, $$ } from './plugins/selectors'

let images = [...$$('.lazy-image')]

const interactSettings = {
    rootMargin: '0px 0px 200px 0px'
}

function onIntersection(imageEntites) {
    imageEntites.forEach(image => {
        if (image.isIntersecting) {
            observer.unobserve(image.target)
            image.target.src = image.target.dataset.src
            image.target.onload = () => image.target.classList.add('loaded')
        }
    })
}

let observer = new IntersectionObserver(onIntersection, interactSettings)

images.forEach(image => observer.observe(image))

if ($('#publication-form')) {
    require('./publication-form')
}

$('#button-up').addEventListener('click', () => {
    window.scrollTo(0, 0)
})

$('#deploy').addEventListener('click', async () => {
    $('#deploy').classList.add('hidden')
    $('#deploying').classList.remove('hidden')
    const response = await fetch('https://api.netlify.com/build_hooks/5f3d27d61392bbd6a7416fff', {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json'
        },
    });
    $('#deploy').classList.remove('hidden')
    $('#deploying').classList.add('hidden')
    return response.json();
})